<div class="notifications-wrapper">
    @for (notification of notifications; track notification.id) {
    <div class="notification" (click)="dismiss(notification.id)">
        @if(notification.action.status !== 'success') {
        <div class="timing-bar"></div>
        }
        @if(notification.action.status === 'success') {
        <div>
            <mat-progress-spinner color="warn" mode="indeterminate" diameter="28" class="processing-spinner"></mat-progress-spinner>
        </div>
        }
        <div class="message">
            {{ notification.action.message }}
        </div>
    </div>
    }
</div>